import SaudeNavbar from './components/SaudeNavbar';
import SaudeHero from './components/SaudeHero';
import SaudeFrentes from './components/SaudeFrentes';
import DiscriminacaoCredito from './components/DiscriminacaoCredito';
import JornadaIncentivo from './components/JornadaIncentivo';
import CanaisCorretores from './components/CanaisCorretores';
import RankingGamificacao from './components/RankingGamificacao';
import PortalRegras from './components/PortalRegras';
import IntegracoesDashboard from './components/IntegracoesDashboard';
import BeneficiariosReconhecimento from './components/BeneficiariosReconhecimento';
import SaudeFooter from './components/SaudeFooter';

export default function SaudePage() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <SaudeNavbar />
      <main>
        <SaudeHero />
        <SaudeFrentes />
        <DiscriminacaoCredito />
        <JornadaIncentivo />
        <CanaisCorretores />
        <RankingGamificacao />
        <PortalRegras />
        <IntegracoesDashboard />
        <BeneficiariosReconhecimento />
      </main>
      <SaudeFooter />
    </div>
  );
}